import { render, staticRenderFns } from "./CategoryLegend.vue?vue&type=template&id=50c42355&scoped=true"
import script from "./CategoryLegend.vue?vue&type=script&lang=js"
export * from "./CategoryLegend.vue?vue&type=script&lang=js"
import style0 from "./CategoryLegend.vue?vue&type=style&index=0&id=50c42355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c42355",
  null
  
)

export default component.exports